import triggersService from './triggersService'

export default triggersService



// WEBPACK FOOTER //
// ../src/services/triggersService/index.js